import script from "./MagatraCopyright.vue?vue&type=script&setup=true&lang=js"
export * from "./MagatraCopyright.vue?vue&type=script&setup=true&lang=js"

import "./MagatraCopyright.vue?vue&type=style&index=0&id=02576734&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02576734"]])

export default __exports__